<div class="text-center wow pulse" data-wow-iteration="2" data-wow-duration="0.2">
  <h3 class="text-info">What Clients Say</h3>
  <h5 class="text-primary">Testimonials</h5>
</div>
<div #swiperCoverflowContainer class="swiper-container">
  <div class="swiper-wrapper">
    @for (slide of slides; track $index) {

    <div class="swiper-slide p-4">
      <p class="m-0">
        {{ slide?.message }}
      </p>
      <hr class="mt-5 mb-4" />
      <div class="user-box d-flex align-items-center">
        <div class="img-box me-3 rounded-circle position-relative">
          <img [src]="imagePath+slide?.id+'/'+ slide?.image" alt="" class="rounded-circle"
            onerror="this.src='assets/images/default-img.png'" />
        </div>
        <div>
          <h6 class="fw-bold m-0 text-primary">{{ slide?.author }}</h6>
        </div>
      </div>
    </div>
    }
  </div>
</div>
<div class="swiper-button-prev"></div>
<div class="swiper-button-next"></div>